/* eslint-disable */
export const generateHashFromString = (stringData) => {
  let hash = 0;
  // stringData = '' + stringData;
  if (stringData.length == 0) return hash;
	for (let i = 0; i < stringData.length; i++) {
		let char = stringData.charCodeAt(i);
		hash = ((hash<<5)-hash)+char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash;
};